import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=08cedf92"
import script from "./LogoutButton.vue?vue&type=script&lang=ts"
export * from "./LogoutButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports